import { EditCommentComponent } from './../edit-comment/edit-comment.component';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Comment } from 'sharedTypes/client';
import { AuthService } from 'src/app/services/auth.service';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
    selector: 'app-comment',
    standalone: false,
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.scss'],
})
export class CommentComponent implements OnInit {
    @Input() comment: Comment = new Comment();
    @Input() allComments: Comment[] = [];
    @Input() folder = 'comments';
    myComment = false;
    userName = '';
    tooltip = '';
    archivTooltip = '';
    uComments: Comment[] = [];
    constructor(
        public authService: AuthService,
        public dialog: MatDialog,
        private datePipe: DatePipe,
        public firebaseService: FirebaseService,
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        this.uComments = this.allComments.filter((c) => c.parentCommentId === this.comment.id);
        this.setIstMeine();
    }

    setIstMeine() {
        if (this.comment.createdBy === this.authService.getUid()) {
            this.myComment = true;
        } else {
            this.myComment = false;
        }
        this.userName = this.comment.createdByName || '';
    }

    ngOnInit(): void {
        this.uComments = this.allComments.filter((notiz) => notiz.parentCommentId === this.comment.id);
        this.setIstMeine();
    }

    addReply() {
        const comment = new Comment();
        comment.parentCommentId = this.comment.id;
        comment.createdBySupport = true;
        comment.clientAccount = this.comment.clientAccount;

        comment.parentType = this.comment.parentType;
        comment.parentId = this.comment.parentId;

        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        cfg.data = { comment };

        console.log(this.folder);
        const dialogRef = this.dialog.open(EditCommentComponent, cfg);
        return dialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
                console.log(result);
                this.firebaseService.saveComment(result, this.folder);
            }
        });
    }

    editComment(comment: Comment) {
        const commentToEdit = JSON.parse(JSON.stringify(comment));
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        cfg.data = { comment: commentToEdit };

        const dialogRef = this.dialog.open(EditCommentComponent, cfg);
        return dialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
                const jetzt = new Date().getTime();
                result.editedAt = jetzt;
                result.edits.push({ text: result.text, unix: jetzt });
                this.firebaseService.saveComment(result, this.folder);
            }
        });
    }
}
